"use strict";
'use es6';
/**
 * The following types are accepted by the backend as `referencedObjectType`s.
 *
 * https://git.hubteam.com/HubSpot/Properties/blob/master/PropertiesCommon/src/main/java/com/hubspot/properties/exceptions/PropertyInvalidException.java#L150
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER = exports.TICKET_STAGE = exports.TICKET_PIPELINE = exports.TEAM = exports.SALESFORCE_CAMPAIGN = exports.PERSONA = exports.MULTI_CURRENCY_CURRENCY_CODE = exports.LIST = exports.INBOUND_DB_IMPORT = exports.FORM = exports.DEAL_STAGE = exports.DEAL_PIPELINE = exports.CONTACT = exports.COMPANY = exports.CAMPAIGN = exports.CALL_DISPOSITION = exports.ADS_LINKEDIN_CAMPAIGN = exports.ADS_LINKEDIN_ADGROUP = exports.ADS_LINKEDIN_AD = exports.ADS_GOOGLE_KEYWORD = exports.ADS_GOOGLE_CAMPAIGN = exports.ADS_GOOGLE_ADGROUP = exports.ADS_GOOGLE_AD = exports.ADS_FACEBOOK_CAMPAIGN = exports.ADS_FACEBOOK_ADGROUP = exports.ADS_FACEBOOK_AD = exports.ACTIVITY_TYPE = exports.OWNER = void 0;
var OWNER = 'OWNER';
/**
 * The following types aren't supported as `referencedObjectType`s by the
 * backend, but we treat the as reference types on the front end because their
 * options are external to the property definition.
 */

exports.OWNER = OWNER;
var ACTIVITY_TYPE = 'ACTIVITY_TYPE';
exports.ACTIVITY_TYPE = ACTIVITY_TYPE;
var ADS_FACEBOOK_AD = 'ADS_FACEBOOK_AD';
exports.ADS_FACEBOOK_AD = ADS_FACEBOOK_AD;
var ADS_FACEBOOK_ADGROUP = 'ADS_FACEBOOK_ADGROUP';
exports.ADS_FACEBOOK_ADGROUP = ADS_FACEBOOK_ADGROUP;
var ADS_FACEBOOK_CAMPAIGN = 'ADS_FACEBOOK_CAMPAIGN';
exports.ADS_FACEBOOK_CAMPAIGN = ADS_FACEBOOK_CAMPAIGN;
var ADS_GOOGLE_AD = 'ADS_GOOGLE_AD';
exports.ADS_GOOGLE_AD = ADS_GOOGLE_AD;
var ADS_GOOGLE_ADGROUP = 'ADS_GOOGLE_ADGROUP';
exports.ADS_GOOGLE_ADGROUP = ADS_GOOGLE_ADGROUP;
var ADS_GOOGLE_CAMPAIGN = 'ADS_GOOGLE_CAMPAIGN';
exports.ADS_GOOGLE_CAMPAIGN = ADS_GOOGLE_CAMPAIGN;
var ADS_GOOGLE_KEYWORD = 'ADS_GOOGLE_KEYWORD';
exports.ADS_GOOGLE_KEYWORD = ADS_GOOGLE_KEYWORD;
var ADS_LINKEDIN_AD = 'ADS_LINKEDIN_AD';
exports.ADS_LINKEDIN_AD = ADS_LINKEDIN_AD;
var ADS_LINKEDIN_ADGROUP = 'ADS_LINKEDIN_ADGROUP';
exports.ADS_LINKEDIN_ADGROUP = ADS_LINKEDIN_ADGROUP;
var ADS_LINKEDIN_CAMPAIGN = 'ADS_LINKEDIN_CAMPAIGN';
exports.ADS_LINKEDIN_CAMPAIGN = ADS_LINKEDIN_CAMPAIGN;
var CALL_DISPOSITION = 'CALL_DISPOSITION';
exports.CALL_DISPOSITION = CALL_DISPOSITION;
var CAMPAIGN = 'CAMPAIGN';
exports.CAMPAIGN = CAMPAIGN;
var COMPANY = 'COMPANY';
exports.COMPANY = COMPANY;
var CONTACT = 'CONTACT';
exports.CONTACT = CONTACT;
var DEAL_PIPELINE = 'DEAL_PIPELINE';
exports.DEAL_PIPELINE = DEAL_PIPELINE;
var DEAL_STAGE = 'DEAL_STAGE';
exports.DEAL_STAGE = DEAL_STAGE;
var FORM = 'FORM';
exports.FORM = FORM;
var INBOUND_DB_IMPORT = '_inbounddbio.importid_';
exports.INBOUND_DB_IMPORT = INBOUND_DB_IMPORT;
var LIST = 'LIST';
exports.LIST = LIST;
var MULTI_CURRENCY_CURRENCY_CODE = 'MULTI_CURRENCY_CURRENCY_CODE';
exports.MULTI_CURRENCY_CURRENCY_CODE = MULTI_CURRENCY_CURRENCY_CODE;
var PERSONA = 'PERSONA';
exports.PERSONA = PERSONA;
var SALESFORCE_CAMPAIGN = 'SALESFORCE_CAMPAIGN';
exports.SALESFORCE_CAMPAIGN = SALESFORCE_CAMPAIGN;
var TEAM = 'TEAM';
exports.TEAM = TEAM;
var TICKET_PIPELINE = 'TICKET_PIPELINE';
exports.TICKET_PIPELINE = TICKET_PIPELINE;
var TICKET_STAGE = 'TICKET_STAGE';
exports.TICKET_STAGE = TICKET_STAGE;
var USER = 'USER';
exports.USER = USER;